import * as React from 'react';
import type { SVGProps } from 'react';
const SvgCustomDashboards = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="currentColor"
    viewBox="0 0 20 20"
    {...props}
  >
    <rect width={5} height={5} x={3} y={3} rx={1} />
    <rect width={7} height={5} x={10} y={3} rx={1} />
    <rect width={8} height={7} x={3} y={10} rx={1} />
    <rect width={4} height={7} x={13} y={10} rx={1} />
  </svg>
);
export default SvgCustomDashboards;
